module.exports = __webpack_public_path__ + "static/media/About.2c16c21c.jpg";